export const economySeatBenefits = [
  'Reclining seat w/ adjustable headrest',
  'Table & power outlet',
  'Comfortable 1.02-meter seat pitch',
  '25cm foot area luggage space',
];

export const firstClassSeatBenefits = [
  'Leather seat w/ adjustable headrest',
  'Sliding table & power outlet',
  'Wide 1.16-meter seat pitch',
  '25cm foot area luggage space',
];

export const whitelistStations = [
  'Chiba',
  'Tokyo',
  'Yokohama',
  'Shibuya',
  'Shinjuku',
  'Ikebukuro',
];
